var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    fillRule: "evenodd",
    d: "M19.03 6.03a.75.75 0 0 0-1.06-1.06L12 10.94 6.03 4.97a.75.75 0 0 0-1.06 1.06L10.94 12l-5.97 5.97a.75.75 0 1 0 1.06 1.06L12 13.06l5.97 5.97a.75.75 0 1 0 1.06-1.06L13.06 12z",
    clipRule: "evenodd"
  })));
};
export default SvgClose;